export const GET_WALK_IN_CONSENT_QA_DATA = "GET_WALK_IN_CONSENT_QA_DATA";
export const CLEAR_WALK_IN_CONSENT_QA_DATA = "CLEAR_WALK_IN_CONSENT_QA_DATA";
